const options = { method: 'GET' };
const version = '1.20';
const now = new Date().toString();
const baseUrl = 'https://www.bobjane.com.au/collections/vehicle-lookup';
const menuSpinner = document.getElementById('menu-spinner');
const menuMakeString = `${url}/makes?subscription-key=${key}`;
const menuRegoFilters = document.getElementById('menu-rego-filters');
const menuRego = document.getElementById('menu-rego');
const menuRegoSearch = document.getElementById('menu-regoSearch');
const menuStates = document.getElementById('menu-states');
const menusbr = document.getElementById('menu-sbr');
const menuVehicleFilters = document.getElementById('menu-vehicle-filters');
const menuMake = document.getElementById('menu-makes');
const menuYear = document.getElementById('menu-years');
const menuModel = document.getElementById('menu-models');
const menuSeries = document.getElementById('menu-series');
const menuLookup = document.getElementById('menu-lookup');
const menusbv = document.getElementById('menu-sbv');
const overlay = document.getElementById('rs-popup-overlay');
const popup = document.getElementById('rs-popup');
const regoError = document.getElementById('regoError');
const vehicleError = document.getElementById('vehicleError');
const vehicleConfirm = document.getElementById('vehicleConfirm');
let reject = false;
let rejectCarry;
let searchCarry;
let historyObject = [];
let historyList = localStorage.getItem('vehicleList');
if (historyList) {
    historyList = historyList.split(',');
    for (i = 0; i < historyList.length; i++) {
        if(typeof localStorage.getItem(`fitmentInfo${historyList[i]}`) == 'string') {
            historyObject.push(JSON.parse(localStorage.getItem(`fitmentInfo${historyList[i]}`)));
        } else {
            historyObject.push(localStorage.getItem(`fitmentInfo${historyList[i]}`));
        }
    }
}

//listener for disclaimer close button
document.getElementById('rs-close').addEventListener('click', function () {
    regoError.style.display = 'none';
    vehicleError.style.display = 'none';
    overlay.style.display = 'none';
    popup.style.display = 'none';
});

//listener for rego retry button
document.getElementById('tryAgain').addEventListener('click', function () {
    if (menuRego) {
        menuRego.value = "";
        menuStates.selectedIndex = 0;
        menuStates.disabled = true;
        menuRegoSearch.disabled = true;
    }
    if (mobMenuRego) {
        mobMenuRego.value = "";
        mobMenuStates.selectedIndex = 0;
        mobMenuStates.disabled = true;
        mobMenuRegoSearch.disabled = true;
    }
    if (rego) {
        rego.value = "";
        states.selectedIndex = 0;
        states.disabled = true;
        regoSearch.disabled = true;
    }
    regoError.style.display = 'none';
    vehicleError.style.display = 'none';
    overlay.style.display = 'none';
    popup.style.display = 'none';
    grecaptcha.reset();
});

if (document.getElementById('tryAgainMob')) {
    document.getElementById('tryAgainMob').addEventListener('click', function () {
        if (menuRego) {
            menuRego.value = "";
            menuStates.selectedIndex = 0;
            menuStates.disabled = true;
            menuRegoSearch.disabled = true;
        }
        if (mobMenuRego) {
            mobMenuRego.value = "";
            mobMenuStates.selectedIndex = 0;
            mobMenuStates.disabled = true;
            mobMenuRegoSearch.disabled = true;
        }
        if (rego) {
            rego.value = "";
            states.selectedIndex = 0;
            states.disabled = true;
            regoSearch.disabled = true;
        }
        regoError.style.display = 'none';
        vehicleError.style.display = 'none';
        overlay.style.display = 'none';
        popup.style.display = 'none';
        grecaptcha.reset();
    });
};

//listener for vehicle selector retry/refresh button
document.getElementById('vRetry').addEventListener('click', function () {
    location.reload();
});

if (document.getElementById('vRetryMob')) {
    document.getElementById('vRetryMob').addEventListener('click', function () {
        location.reload();
    });
}

//listener for rego use vehicle selector instead button
document.getElementById('choose').addEventListener('click', function () {
    if (sbr) {
        if (!sbv.classList.value.includes('switchActive')) {
            regoFilters.style.display = 'none';
            vehicleFilters.style.display = 'block';
            setTimeout(() => {
                regoFilters.style.opacity = 0;
            }, this.animationDelay + 10);
            setTimeout(() => {
                vehicleFilters.style.opacity = 1;
            }, this.animationDelay + 20);
            sbr.classList.toggle('switchActive');
            sbv.classList.toggle('switchActive');
            sbr.classList.toggle('switchOff');
            sbv.classList.toggle('switchOff');
        }
    }
    if (menusbr) {
        if (!menusbv.classList.value.includes('switchActive')) {
            menuRegoFilters.style.display = 'none';
            menuVehicleFilters.style.display = 'block';
            setTimeout(() => {
                menuRegoFilters.style.opacity = 0;
            }, this.animationDelay + 10);
            setTimeout(() => {
                menuVehicleFilters.style.opacity = 1;
            }, this.animationDelay + 20);
            menusbr.classList.toggle('switchActive');
            menusbv.classList.toggle('switchActive');
            menusbr.classList.toggle('switchOff');
            menusbv.classList.toggle('switchOff');
        }
    }
    if (mobMenusbr) {
        if (!mobMenusbv.classList.value.includes('switchActive')) {
            mobMenuRegoFilters.style.display = 'none';
            mobMenuVehicleFilters.style.display = 'block';
            setTimeout(() => {
                mobMenuRegoFilters.style.opacity = 0;
            }, this.animationDelay + 10);
            setTimeout(() => {
                mobMenuVehicleFilters.style.opacity = 1;
            }, this.animationDelay + 20);
            mobMenusbr.classList.toggle('switchActive');
            mobMenusbv.classList.toggle('switchActive');
            mobMenusbr.classList.toggle('switchOff');
            mobMenusbv.classList.toggle('switchOff');
        }
    }
    overlay.style.display = 'none';
    popup.style.display = 'none';
});

if (document.getElementById('chooseMob')) {
    document.getElementById('chooseMob').addEventListener('click', function () {
        if (sbr) {
            if (!sbv.classList.value.includes('switchActive')) {
                regoFilters.style.display = 'none';
                vehicleFilters.style.display = 'block';
                setTimeout(() => {
                    regoFilters.style.opacity = 0;
                }, this.animationDelay + 10);
                setTimeout(() => {
                    vehicleFilters.style.opacity = 1;
                }, this.animationDelay + 20);
                sbr.classList.toggle('switchActive');
                sbv.classList.toggle('switchActive');
                sbr.classList.toggle('switchOff');
                sbv.classList.toggle('switchOff');
            }
        }
        if (menusbr) {
            if (!menusbv.classList.value.includes('switchActive')) {
                menuRegoFilters.style.display = 'none';
                menuVehicleFilters.style.display = 'block';
                setTimeout(() => {
                    menuRegoFilters.style.opacity = 0;
                }, this.animationDelay + 10);
                setTimeout(() => {
                    menuVehicleFilters.style.opacity = 1;
                }, this.animationDelay + 20);
                menusbr.classList.toggle('switchActive');
                menusbv.classList.toggle('switchActive');
                menusbr.classList.toggle('switchOff');
                menusbv.classList.toggle('switchOff');
            }
        }
        if (mobMenusbr) {
            if (!mobMenusbv.classList.value.includes('switchActive')) {
                mobMenuRegoFilters.style.display = 'none';
                mobMenuVehicleFilters.style.display = 'block';
                setTimeout(() => {
                    mobMenuRegoFilters.style.opacity = 0;
                }, this.animationDelay + 10);
                setTimeout(() => {
                    mobMenuVehicleFilters.style.opacity = 1;
                }, this.animationDelay + 20);
                mobMenusbr.classList.toggle('switchActive');
                mobMenusbv.classList.toggle('switchActive');
                mobMenusbr.classList.toggle('switchOff');
                mobMenusbv.classList.toggle('switchOff');
            }
        }
        overlay.style.display = 'none';
        popup.style.display = 'none';
    });
}

//load data for dropdowns and check for locally stored selection data
document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('menu-vehicle-filters')) {
        if (localStorage.getItem('makeList')) {
            menuMake.innerHTML = localStorage.getItem('makeList');
            menuMake.disabled = false;
            if (localStorage.getItem('makeSelection')) {
                menuMake.selectedIndex = localStorage.getItem('makeSelection');
                makeMove(menuMake, menuYear, menuModel, menuSeries, menuLookup, menuSpinner);
            }
        } else {
            retrieveMakes(menuMakeString, options, menuSpinner, menuMake);
        }

        //listen for inputs on dropboxes
        menuMake.addEventListener('input', function () {
            storageWiper(6);
            dropDownSwitches(3, menuSeries, menuModel, menuYear);
            makeMove(menuMake, menuYear, menuModel, menuSeries, menuLookup, menuSpinner);
        });

        menuYear.addEventListener('input', function () {
            storageWiper(4);
            dropDownSwitches(2, menuSeries, menuModel, menuYear);
            yearMove(menuModel, menuSeries, menuLookup, menuYear, menuMake, menuSpinner);
        });

        menuModel.addEventListener('input', function () {
            storageWiper(2);
            dropDownSwitches(1, menuSeries, menuModel, menuYear);
            modelMove(menuSeries, menuLookup, menuModel, menuYear, menuSpinner);
        });

        menuSeries.addEventListener('input', function () {
            seriesMove(menuSeries, menuLookup);
        });

        //listen for click on search
        menuLookup.addEventListener('click', function () {
            let vehicleID = menuSeries.value;
            let reqString = `${url}/fitments/${vehicleID}?subscription-key=${key}`;
            localStorage.setItem('makeSelection', menuMake.selectedIndex);
            localStorage.setItem('yearSelection', menuYear.selectedIndex);
            localStorage.setItem('modelSelection', menuModel.selectedIndex);
            localStorage.setItem('seriesSelection', menuSeries.selectedIndex);
            searchVehicle(reqString, options, vehicleID, '', menuSpinner, menuMake, menuYear, menuModel, menuSeries, menusbv);
        });
    }
    //Populate previous search history
    if (localStorage.getItem('vehicleList')) {
        let historyContent = '';
        let historyMobContent = '';
        let historyCount = 0;
        let historyItem
        let fitString
        for (i = 0; i < historyObject.length; i++) {
            historyItem = historyObject[i];
            if (historyItem) {
                historyItem.expiry = Number(historyItem.expiry)
            };
            if (historyItem && historyItem.version == version && historyItem.expiry > Date.parse(now) && historyItem.makeModel) {
                historyCount = historyCount + 1;
                if (historyCount < 3) {
                    historyContent = `${historyContent}<div class="historyItem" data-id="${historyItem.id}">${historyItem.makeModel}</div>`
                }
                if (historyCount < 3) {
                    historyMobContent = `${historyMobContent}<h2 class="block-section-title previousSearchesMobile"><div class="historyItemMob" data-id="${historyItem.id}">${historyItem.makeModel}</div></h2>`
                }
            } else {
                localStorage.removeItem(`vehicleInfo${historyList[i]}`);
                if (historyItem) {
                    localStorage.removeItem(`fitmentInfo${historyItem.vehicle_id}`);
                }
                historyList.splice(historyList.indexOf(historyList[i]), 1)
                continue;
            }
            localStorage.setItem('vehicleList', historyList.toString());
        }
        if (historyContent.length > 0) {
            historyContent = `<h2 class="block-section-title previousSearches">Previously searched:${historyContent}</h2>`;
            historyMobContent = `<h2 class="block-section-title previousSearchesMobile">Previously searched:</h2>${historyMobContent}</h2>`;
            let deskHistory = document.getElementsByClassName('prevSearches');
            let mobHistory = document.getElementsByClassName('prevSearchesMob');
            let menuHistory = document.getElementsByClassName('prevSearchesMenu');
            for (i = 0; i < deskHistory.length; i++) {
                deskHistory[i].innerHTML = historyContent;
            };
            for (i = 0; i < mobHistory.length; i++) {
                mobHistory[i].innerHTML = historyMobContent;
            }
            for (i = 0; i < menuHistory.length; i++) {
                menuHistory[i].innerHTML = historyMobContent;
            }
        }
        let pastVehicles = document.getElementsByClassName('historyItem');
        for (i = 0; i < pastVehicles.length; i++) {
            pastVehicles[i].addEventListener('click', function () {
                pastVehicle(this.dataset.id, this.innerHTML);
            });
        }
        let pastVehiclesMob = document.getElementsByClassName('historyItemMob');
        for (i = 0; i < pastVehiclesMob.length; i++) {
            pastVehiclesMob[i].addEventListener('click', function () {
                pastVehicle(this.dataset.id, this.innerHTML);
            });
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('menu-rego-filters')) {
        if (localStorage.getItem('regoString')) {
            menuRego.value = localStorage.getItem('regoString');
            menuStates.disabled = false;
            if (localStorage.getItem('regoState')) {
                menuStates.selectedIndex = localStorage.getItem('regoState');
                stateActive(menuRegoSearch, menuSpinner, menuRego, menuStates, menusbr, menuMake, menuYear, menuModel, menuSeries, menusbv);
            }
        }
        //listener for rego and states inputs to enable/disable inputs and search button
        menuRego.addEventListener('input', function () {
            if (menuRego.value.length > 0) {
                menuStates.disabled = false;
            } else if (menuRego.value.length == 0) {
                menuStates.disabled = true;
                menuStates.selectedIndex = 0;
                menuRegoSearch.style.cursor = 'none';
                menuRegoSearch.style.opacity = '0.8';
                menuRegoSearch.disabled = true;
            }
        });

        menuStates.addEventListener('input', function () {
            if (menuStates.value.length > 0) {
                stateActive(menuRegoSearch, menuSpinner, menuRego, menuStates, menusbr, menuMake, menuYear, menuModel, menuSeries, menusbv)
            } else if (menuStates.value.length == 0) {
                menuRegoSearch.style.cursor = 'none';
                menuRegoSearch.style.opacity = '0.8';
                menuRegoSearch.disabled = true;
                menuRegoSearch.removeEventListener('click', function () {
                    onFind(menuSpinner, menuRego, menuStates, menusbr, menuMake, menuYear, menuModel, menuSeries, menusbv);
                    //searchRego(menuSpinner, menuRego, menuStates, menusbr, menuMake, menuYear, menuModel, menuSeries, menusbv);
                });
            }
        });
    }
});

function stateActive(X, Y, Z, A, B, F, G, H, I, J) {
    X.style.cursor = 'pointer';
    X.style.opacity = '1';
    X.disabled = false;
    X.addEventListener('click', function () {
        X.disabled = true;
        X.style.cursor = 'none';
        X.style.opacity = '0.8';
        onFind(Y, Z, A, B, F, G, H, I, J);
        //searchRego(Y, Z, A, B, F, G, H, I, J);
    });
}

//fetch makes from API, render and store locally
async function retrieveMakes(X, Y, Z, A) {
    spinOn(Z);
    let optionString = '';
    let resp = await fetch(X, Y);
    let ans = await resp.json();
    ans = nameSort(ans);
    for (i = 0; i < ans.length; i++) {
        optionString = `${optionString}<option data-idx="${i}" value="${ans[i].id}">${ans[i].display_name}</option>`;
    }
    A.innerHTML = `<option class="default" value="" selected hidden>Vehicle Make</option>${optionString}`;
    localStorage.setItem('makeList', `<option class="default" value="" selected hidden>Vehicle Make</option>${optionString}`);
    spinOff(Z);
    A.disabled = false;
    return;
}

//fetch years from API, render and store locally
async function retrieveYears(X, Y, Z, A, B) {
    spinOn(A);
    let currentYear = new Date().getFullYear();
    let resp = await fetch(X, Y);
    let ans = await resp.json();
    ans = nameSort(ans);
    let lowerYear = ans[Z].year_from;
    let upperYear = ans[Z].year_to;
    let optionString = '';
    for (i = lowerYear; i <= upperYear; i++) {
        optionString = `${optionString}<option value="${i}">${i}</option>`;
        if (i == currentYear) {
            break;
        }
    }
    B.innerHTML = `<option class="default" value="" selected hidden>Vehicle Year</option>${optionString}`;
    localStorage.setItem('yearList', `<option class="default" value="" selected hidden>Vehicle Year</option>${optionString}`);
    spinOff(A);
    B.disabled = false;
    return;
}

//fetch models from API, render and store locally
async function retrieveModels(X, Y, Z, A) {
    spinOn(Z);
    let optionString = '';
    let resp = await fetch(X, Y);
    let ans = await resp.json();
    ans = nameSort(ans);
    for (i = 0; i < ans.length; i++) {
        optionString = `${optionString}<option value="${ans[i].id}">${ans[i].display_name}</option>`;
    }
    A.innerHTML = `<option class="default" value="" selected hidden>Vehicle Model</option>${optionString}`;
    localStorage.setItem('modelList', `<option class="default" value="" selected hidden>Vehicle Model</option>${optionString}`);
    spinOff(Z);
    A.disabled = false;
    return;
}

//fetch series from API, render and store locally
async function retrieveSeries(X, Y, Z, A, B) {
    spinOn(B);
    let resp = await fetch(X, Y);
    let ans = await resp.json();
    ans = nameSort(ans);
    let optionString = '';
    for (i = 0; i < ans.length; i++) {
        optionString = `${optionString}<option value="${ans[i].id}">${ans[i].display_name}</option>`;
    }
    Z.innerHTML = `<option class="default" value="" selected hidden>Vehicle Series</option>${optionString}`;
    localStorage.setItem('seriesList', `<option class="default" value="" selected hidden>Vehicle Series</option>${optionString}`);
    spinOff(B);
    Z.disabled = false;
    A.disabled = false;
    return;
}

//fetch fitments from API, store information in session storage, construct url/param string for filtered results and redirect
async function searchVehicle(X, Y, Z, A, B, C, D, E, F, G, H) {
    spinOn(B);
    sessionStorage.removeItem('altFitDisclaimer')
    let modelString = '';
    if (A.length > 0) {
        modelString = A;
    } else {
        modelString = `${C.options[C.selectedIndex].text}+${D.options[D.selectedIndex].text}+${E.options[E.selectedIndex].text}+${F.options[F.selectedIndex].text}`;
    }
    let fitmentInfo = localStorage.getItem(`fitmentInfo${Z}`);
    if (fitmentInfo && fitmentInfo.version == version && Number(fitmentInfo.expiry) > Date.parse(now) && Z == fitmentInfo.id) {
        if (localStorage.getItem('vehicleList')) {
            let vehicleList = localStorage.getItem('vehicleList').split(',');
            if (!vehicleList.includes(`${Z}`)) {
                vehicleList.unshift(`${Z}`);
                localStorage.setItem(`vehicleList`, vehicleList.toString());
            } else {
                vehicleList.splice(vehicleList.indexOf(`${Z}`), 1);
                vehicleList.unshift(`${Z}`);
                localStorage.setItem(`vehicleList`, vehicleList.toString());
            }
        } else {
            let vehicleList = [];
            vehicleList.unshift(`${Z}`);
            localStorage.setItem(`vehicleList`, vehicleList.toString());
        }
        let filter = '';
        let runFlat = 0;
        if (fitmentInfo.is_run_flat) {
            runFlat = 1;
        }
        let idx = 0;
        let oeidx = 0;
        for (i = 0; i < fitmentInfo.fitments.length; i++) {
            if (fitmentInfo.fitments[i].oe) {
                idx = fitmentInfo.fitments[i].id;
                oeidx = i;
            }
        }
        for (z = 0; z < fitmentInfo.fitments[oeidx].f_tyres.matches.length; z++) {
            filter = `${filter}&filter.v.m.tyre_spec.size_full=${fitmentInfo.fitments[oeidx].f_tyres.matches[z]}`;
        }
        filter = filter.replaceAll(' ', '+');
        let destination = `${baseUrl}?model=${modelString}&ID=${Z}${filter}&filter.v.m.tyre_spec.run_flat=${runFlat}&idx=${idx}`;
        window.location.href = destination;
        setTimeout(spinOff, 500, B);
    } else {
        localStorage.removeItem(`fitmentInfo${Z}`);
        let resp = await fetch(X, Y);
        let errorTimeout = setTimeout(errorHandle, 9000, vehicleError, overlay, popup, B);
        if (resp.status > 299 && G.classList.value.includes('switchActive')) {
            clearTimeout(errorTimeout);
            errorHandle(vehicleError, overlay, popup, B);
            return;
        } else {
            let validate = await resp.text();
            if (validate.includes("vehicle_id")) {
                let ans = JSON.parse(validate);
                ans.version = version;
                ans.expiry = (Date.parse(now) + (28 * 24 * 60 * 60 * 1000)).toString();
                if (H) {
                    ans.makeModel = H;
                } else {
                    ans.makeModel = `${C.options[C.selectedIndex].text} ${E.options[E.selectedIndex].text}`;
                }
                localStorage.setItem(`fitmentInfo${Z}`, JSON.stringify(ans));
                if (localStorage.getItem('vehicleList')) {
                    let vehicleList = localStorage.getItem('vehicleList').split(',');
                    if (!vehicleList.includes(`${Z}`)) {
                        vehicleList.unshift(`${Z}`);
                        localStorage.setItem(`vehicleList`, vehicleList.toString());
                    } else {
                        vehicleList.splice(vehicleList.indexOf(`${Z}`), 1);
                        vehicleList.unshift(`${Z}`);
                        localStorage.setItem(`vehicleList`, vehicleList.toString());
                    }
                } else {
                    let vehicleList = [];
                    vehicleList.unshift(`${Z}`);
                    localStorage.setItem(`vehicleList`, vehicleList.toString());
                    if (!localStorage.getItem(`vehicleList`)) {
                        localStorage.setItem(`vehicleList`, vehicleList.toString());
                    }
                }
                let filter = '';
                let runFlat = 0;
                if (ans.is_run_flat) {
                    runFlat = 1;
                }
                let idx = 0;
                let oeidx = 0;
                for (i = 0; i < ans.fitments.length; i++) {
                    if (ans.fitments[i].oe) {
                        idx = ans.fitments[i].id;
                        oeidx = i;
                    }
                }
                for (z = 0; z < ans.fitments[oeidx].f_tyres.matches.length; z++) {
                    filter = `${filter}&filter.v.m.tyre_spec.size_full=${ans.fitments[oeidx].f_tyres.matches[z]}`;
                }
                filter = filter.replaceAll(' ', '+');
                let destination = `${baseUrl}?model=${modelString}&ID=${Z}${filter}&filter.v.m.tyre_spec.run_flat=${runFlat}&idx=${idx}`;
                window.location.href = destination;
                setTimeout(spinOff, 500, B);
            } else if (G.classList.value.includes('switchActive')) {
                clearTimeout(errorTimeout);
                errorHandle(vehicleError, overlay, popup, B);
                return;
            }
        }
    }
}

//submits rego to API and sends returned vehicleID to vehicle selector process
async function searchRego(X, Y, Z, A, E, F, G, H, I, J) {
    rejectCarry = [X, Y, Z, A, E, F, G, H, I];
    spinOn(X)
    let regInput = Y.value.toLowerCase()
    let regoInfo = localStorage.getItem(`regoInfo${regInput}`);
    if (regoInfo) {
        regoInfo = JSON.parse(regoInfo);
    }
    if (regoInfo && regoInfo.version == version && Number(regoInfo.expiry) > Date.parse(now) && regoInfo.rego == regInput && regoInfo.state == Z.value) {
        let nameString = '';
        if (regoInfo.make && regoInfo.make.display_name) {
            nameString = `${regoInfo.make.display_name} `;
        }
        if (regoInfo.model && regoInfo.model.display_name) {
            nameString = `${nameString}${regoInfo.model.display_name} `
        }
        nameString = `${nameString}${regoInfo.display_name}`
        let reqString = `${url}/fitments/${regoInfo.id}?subscription-key=${key}`;
        searchVehicle(reqString, options, regoInfo.id, nameString, X, E, F, G, H, I, `${regoInfo.make.display_name} ${regoInfo.model.display_name}`);
    } else {
        if (regoInfo && regoInfo.rego == regInput) {
            localStorage.removeItem(`regoInfo${regInput}`);
            if (localStorage.getItem('regoList')) {
                let list = localStorage.getItem('regoList').split(',');
                if (list.includes(regInput)) {
                    list.splice(list.indexOf(regInput), 1)
                }
            }
        }
        let confirm = '';
        if (reject) {
            confirm = '&rejected=true';
        }
        let regoString = `${url}/live/lpn?lpn=${regInput}&state=${Z.value}&subscription-key=${key}${confirm}`
        let errorTimeout = setTimeout(errorHandle, 9000, vehicleError, overlay, popup, X);
        let reCaptchaOptions = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'recaptcha-token': J
            }
        }
        let resp = await fetch(regoString, reCaptchaOptions);
        if (resp.status > 299 && A.classList.value.includes('switchActive')) {
            clearTimeout(errorTimeout);
            if (resp.status == 429 || resp.status == 500) {
                errorHandle(vehicleError, overlay, popup, X);
            } else {
                errorHandle(regoError, overlay, popup, X);
            }
            return;
        } else {
            let validate = await resp.text();
            if (validate.includes('vehicle_id')) {
                clearTimeout(errorTimeout);
                let ans = JSON.parse(validate);
                localStorage.setItem('regoString', Y.value);
                localStorage.setItem('regoState', Z.selectedIndex);
                if (ans.id) {
                    ans.rego = regInput;
                    ans.state = Z.value;
                    ans.version = version;
                    ans.expiry = (Date.parse(now) + (5 * 365 * 24 * 60 * 60 * 1000)).toString();
                    localStorage.setItem(`regoInfo${regInput}`, JSON.stringify(ans));
                    if (localStorage.getItem('regoList')) {
                        let regoList = localStorage.getItem('regoList').split(',');
                        if (!regoList.includes(regInput)) {
                            regoList.unshift(regInput);
                            localStorage.setItem(`regoList`, regoList.toString());
                        } else {
                            regoList.splice(regoList.indexOf(regInput), 1);
                            regoList.unshift(regInput);
                            localStorage.setItem(`regoList`, regoList.toString());
                        }
                    } else {
                        let regoList = [];
                        regoList.unshift(Y.value);
                        localStorage.setItem(`regoList`, regoList.toString());
                    }
                    let nameString = '';
                    if (ans.make && ans.make.display_name) {
                        nameString = `${ans.make.display_name} `;
                    }
                    if (ans.model && ans.model.display_name) {
                        nameString = `${nameString}${ans.model.display_name} `
                    }
                    nameString = `${nameString}${ans.display_name}`
                    let reqString = `${url}/fitments/${ans.id}?subscription-key=${key}`;
                    vConfirm(reqString, options, ans.id, nameString, X, E, F, G, H, I, `${ans.make.display_name} ${ans.model.display_name}`);
                    //searchVehicle(reqString, options, ans.id, nameString, X, E, F, G, H, I, `${ans.make.display_name} ${ans.model.display_name}`);
                }
            } else if (A.classList.value.includes('switchActive')) {
                clearTimeout(errorTimeout);
                errorHandle(regoError, overlay, popup, X);
                return;
            }
        }
    }
}

//trigger popup when API call receives an error
function errorHandle(X, Y, Z, A) {
    spinOff(A);
    Y.style.display = 'block';
    Z.style.display = 'block';
    X.style.display = 'block';
    return;
}

//listeners to switch between vehicle and rego search
function changeSearchListener(X, Y, Z, A) {
    if (X) {
        X.addEventListener('click', function () {
            if (!X.classList.value.includes('switchActive')) {
                Y.style.display = 'block';
                if (Z) {
                    Z.style.display = 'none';
                    setTimeout(() => {
                        Z.style.opacity = 0;
                    }, this.animationDelay + 10);
                    if (A.classList.value.includes('switchActive')) {
                        A.classList.toggle('switchActive');
                        A.classList.toggle('switchOff');
                    }
                }
                setTimeout(() => {
                    Y.style.opacity = 1;
                }, this.animationDelay + 20);
                X.classList.toggle('switchActive');
                X.classList.toggle('switchOff');
            }
        });
    }
}

changeSearchListener(menusbv, menuVehicleFilters, menuRegoFilters, menusbr);
changeSearchListener(menusbr, menuRegoFilters, menuVehicleFilters, menusbv);

//clear stored selection and lists when dropdown value changes
function storageWiper(X) {
    let storageArray = ['seriesList', 'seriesSelection', 'modelList', 'modelSelection', 'yearList', 'yearSelection']
    for (i = 0; i < X; i++) {
        localStorage.removeItem(storageArray[i]);
    }
}

//disable unpopulated dropdowns when earlier dropdown value changes
function dropDownSwitches(X, Y, Z, A) {
    let switchArray = [Y, Z, A]
    for (i = 0; i < X; i++) {
        switchArray[i].disabled = true;
        switchArray[i].options[switchArray[i].selectedIndex].selected = false;
    }
}

//populate years dropdown when make dropdown value is selected
function makeMove(X, Y, Z, A, B, C) {
    let makeIndex = X.options[X.selectedIndex].dataset.idx;
    if (localStorage.getItem('yearList')) {
        Y.innerHTML = localStorage.getItem('yearList');
        Y.disabled = false;
        if (localStorage.getItem('yearSelection')) {
            Y.selectedIndex = localStorage.getItem('yearSelection');
            yearMove(Z, A, B, Y, X, C);
        }
    } else {
        retrieveYears(menuMakeString, options, makeIndex, C, Y);
    }
}

//populate models dropdown when years dropdown value is selected
function yearMove(X, Y, Z, A, B, C) {
    if (localStorage.getItem('modelList')) {
        X.innerHTML = localStorage.getItem('modelList');
        X.disabled = false;
        if (localStorage.getItem('modelSelection')) {
            X.selectedIndex = localStorage.getItem('modelSelection');
            modelMove(Y, Z, X, A, C);
        }
    } else if (A.value) {
        let reqString = `${url}/models/${B.value}?year=${A.value}&subscription-key=${key}`;
        retrieveModels(reqString, options, C, X);
    }
}

//populate series dropdown when models dropdown value is selected
function modelMove(X, Y, Z, A, B) {
    if (localStorage.getItem('seriesList')) {
        X.innerHTML = localStorage.getItem('seriesList');
        X.disabled = false;
        if (localStorage.getItem('seriesSelection')) {
            X.selectedIndex = localStorage.getItem('seriesSelection');
            seriesMove(X, Y);
        }
    } else if (Z.value) {
        let reqString = `${url}/series/${Z.value}?year=${A.value}&subscription-key=${key}`;
        retrieveSeries(reqString, options, X, Y, B);
    }
}

//enable search button when series dropdown value is selected
function seriesMove(X, Y) {
    if (X.value) {
        Y.style.cursor = 'pointer';
        Y.style.opacity = '1';
    } else {
        Y.style.cursor = 'not-allowed';
        Y.style.opacity = '0.8';
    }
}

//activate loading spinner
function spinOn(X) {
    if (X.classList.contains('hidden')) {
        X.classList.remove('hidden');
    }
}

//deactivate loading spinner
function spinOff(X) {
    if (!X.classList.contains('hidden')) {
        X.classList.add('hidden');
    }
}

//sort API results alphabetically
function nameSort(X) {
    X.sort(function (a, b) {
        var textA = a.display_name.toUpperCase();
        var textB = b.display_name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    return X;
}

async function pastVehicle(X, Y) {
    if (document.getElementById('spinner')) {
        spinOn(document.getElementById('spinner'));
    } else if (document.getElementById('mobmenu-spinner')) {
        spinOn(document.getElementById('mobmenu-spinner'));
    } else {
        spinOn(menuSpinner);
    }
    let fitmentInfo
    if (localStorage.getItem(`fitmentInfo${X}`)) {
        fitmentInfo = localStorage.getItem(`fitmentInfo${X}`);
    }
    if (fitmentInfo && fitmentInfo.version == version && Number(fitmentInfo.expiry) > Date.parse(now) && Z == fitmentInfo.id) {
        if (typeof fitmentInfo == 'string') {
            fitmentInfo = JSON.parse(fitmentInfo);
        }
    } else {
        let title = localStorage.getItem(`fitmentInfo${X}`);
        localStorage.removeItem(`fitmentInfo${X}`);
        let reqString = `${url}/fitments/${X}?subscription-key=${key}`;
        let resp = await fetch(reqString, options);
        let errorTimeout
        if (document.getElementById('spinner')) {
            errorTimeout = setTimeout(errorHandle, 9000, spinner, vehicleError, overlay, popup);
        } else if (document.getElementById('mobmenu-spinner')) {
            errorTimeout = setTimeout(errorHandle, 9000, mobMenuSpinner, vehicleError, overlay, popup);
        } else {
            errorTimeout = setTimeout(errorHandle, 9000, menuSpinner, vehicleError, overlay, popup);
        }
        if (resp.status > 299 && G.classList.value.includes('switchActive')) {
            clearTimeout(errorTimeout);
            if (vehicleError) {
                errorHandle(spinner, vehicleError, overlay, popup);
            } else if (document.getElementById('mobMenu-searchContainer')) {
                errorHandle(mobMenuSpinner, vehicleError, overlay, popup);
            } else {
                errorHandle(menuSpinner, vehicleError, overlay, popup);
            }
            return;
        }
        let validate = await resp.text();
        if (validate.includes("vehicle_id")) {
          if(title) {
              if (typeof title == 'string') {
                titel = JSON.parse(title);
              }
            title = title.makeModel;
          }
            let ans = JSON.parse(validate);
            ans.version = version;
            ans.makeModel = title;
            ans.expiry = (Date.parse(now) + (28 * 24 * 60 * 60 * 1000)).toString();
            localStorage.setItem(`fitmentInfo${X}`, JSON.stringify(ans));
            fitmentInfo = ans;
        }
    }
    let filter = '';
    let runFlat = 0;
    if (fitmentInfo.is_run_flat) {
        runFlat = 1;
    }
    let idx = 0;
    let oeidx = 0;
    for (i = 0; i < fitmentInfo.fitments.length; i++) {
        if (fitmentInfo.fitments[i].oe) {
            idx = fitmentInfo.fitments[i].id;
            oeidx = i;
        }
    }
    for (z = 0; z < fitmentInfo.fitments[oeidx].f_tyres.matches.length; z++) {
        filter = `${filter}&filter.v.m.tyre_spec.size_full=${fitmentInfo.fitments[oeidx].f_tyres.matches[z]}`;
    }
    filter = filter.replaceAll(' ', '+');
    let destination = `${baseUrl}?model=${Y}+${fitmentInfo.display_name}&ID=${X}${filter}&filter.v.m.tyre_spec.run_flat=${runFlat}&idx=${idx}`;
    window.location.href = destination;
    if (document.getElementById('spinner')) {
        setTimeout(spinOff, 500, spinner);
    } else if (document.getElementById('mobmenu-spinner')) {
        setTimeout(spinOff, 500, mobMenuSpinner);
    } else {
        setTimeout(spinOff, 500, menuSpinner);
    }
}

function vConfirm(A, B, C, D, E, F, G, H, I, J, K) {
    spinOff(E);
    if (reject) {
        document.getElementById('vName').innerHTML = D;
        document.getElementById('vConfirmNo').innerHTML = 'No';
        overlay.style.display = 'block';
        popup.style.display = 'block';
        vehicleConfirm.style.display = 'block';
        confirmListeners(A, B, C, D, E, F, G, H, I, J, K);
    } else {
        document.getElementById('vName').innerHTML = D;
        overlay.style.display = 'block';
        popup.style.display = 'block';
        vehicleConfirm.style.display = 'block';
        confirmListeners(A, B, C, D, E, F, G, H, I, J, K);
    }

}

function confirmListeners(A, B, C, D, E, F, G, H, I, J, K) {
    document.getElementById('vConfirmYes').addEventListener('click', function () {
        overlay.style.display = 'none';
        popup.style.display = 'none';
        vehicleConfirm.style.display = 'none';
        searchVehicle(A, B, C, D, E, F, G, H, I, J, K);
    });
    document.getElementById('vConfirmYesMob').addEventListener('click', function () {
        overlay.style.display = 'none';
        popup.style.display = 'none';
        vehicleConfirm.style.display = 'none';
        searchVehicle(A, B, C, D, E, F, G, H, I, J, K);
    });
    document.getElementById('vConfirmNo').addEventListener('click', function () {
        if (reject) {
            localStorage.removeItem(`regoInfo${rejectCarry[1].value.toLowerCase()}`);
            noReject();
        } else {
            localStorage.removeItem(`regoInfo${rejectCarry[1].value.toLowerCase()}`);
            reject = true;
            overlay.style.display = 'none';
            popup.style.display = 'none';
            vehicleConfirm.style.display = 'none';
            onFind(rejectCarry[0], rejectCarry[1], rejectCarry[2], rejectCarry[3], rejectCarry[4], rejectCarry[5], rejectCarry[6], rejectCarry[7], rejectCarry[8]);
        }
    });
    document.getElementById('vConfirmNoMob').addEventListener('click', function () {
        if (reject) {
            localStorage.removeItem(`regoInfo${rejectCarry[1].value.toLowerCase()}`);
            noReject();
        } else {
            localStorage.removeItem(`regoInfo${rejectCarry[1].value.toLowerCase()}`);
            reject = true;
            overlay.style.display = 'none';
            popup.style.display = 'none';
            vehicleConfirm.style.display = 'none';
            onFind(rejectCarry[0], rejectCarry[1], rejectCarry[2], rejectCarry[3], rejectCarry[4], rejectCarry[5], rejectCarry[6], rejectCarry[7], rejectCarry[8]);
        }
    });
}

function noReject() {
    if (sbr) {
        if (!sbv.classList.value.includes('switchActive')) {
            regoFilters.style.display = 'none';
            vehicleFilters.style.display = 'block';
            setTimeout(() => {
                regoFilters.style.opacity = 0;
            }, this.animationDelay + 10);
            setTimeout(() => {
                vehicleFilters.style.opacity = 1;
            }, this.animationDelay + 20);
            sbr.classList.toggle('switchActive');
            sbv.classList.toggle('switchActive');
            sbr.classList.toggle('switchOff');
            sbv.classList.toggle('switchOff');
        }
    }
    if (menusbr) {
        if (!menusbv.classList.value.includes('switchActive')) {
            menuRegoFilters.style.display = 'none';
            menuVehicleFilters.style.display = 'block';
            setTimeout(() => {
                menuRegoFilters.style.opacity = 0;
            }, this.animationDelay + 10);
            setTimeout(() => {
                menuVehicleFilters.style.opacity = 1;
            }, this.animationDelay + 20);
            menusbr.classList.toggle('switchActive');
            menusbv.classList.toggle('switchActive');
            menusbr.classList.toggle('switchOff');
            menusbv.classList.toggle('switchOff');
        }
    }
    if (mobMenusbr) {
        if (!mobMenusbv.classList.value.includes('switchActive')) {
            mobMenuRegoFilters.style.display = 'none';
            mobMenuVehicleFilters.style.display = 'block';
            setTimeout(() => {
                mobMenuRegoFilters.style.opacity = 0;
            }, this.animationDelay + 10);
            setTimeout(() => {
                mobMenuVehicleFilters.style.opacity = 1;
            }, this.animationDelay + 20);
            mobMenusbr.classList.toggle('switchActive');
            mobMenusbv.classList.toggle('switchActive');
            mobMenusbr.classList.toggle('switchOff');
            mobMenusbv.classList.toggle('switchOff');
        }
    }
    overlay.style.display = 'none';
    popup.style.display = 'none';
    vehicleConfirm.style.display = 'none';
}

//reCaptcha call
function onFind(A, B, C, D, E, F, G, H, I) {
    if (reject) {
        grecaptcha.reset();
    }
    searchCarry = [A, B, C, D, E, F, G, H, I]
    grecaptcha.execute();
};

//reCaptcha followUp function
function onSearch(token) {
    searchRego(searchCarry[0], searchCarry[1], searchCarry[2], searchCarry[3], searchCarry[4], searchCarry[5], searchCarry[6], searchCarry[7], searchCarry[8], token);
}